/* eslint-disable react-hooks/exhaustive-deps */
import Breadcrumcomponent from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import Page from "components/Page";
import {
  ambienteAplicacion
} from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import withValidarRecuperar from "HOC/withValidarRecuperar";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { PASOS_BREADCRUMBS } from "utils/constants";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import Loading from "wrappers/Loading";
import { Hogar } from "./constantes/general";
import pasosBreadCrumbHogar from "./constantes/pasosBreadCrumb";
import DatosGenerales from "./formas/datosCoberturas";
import "./styles.scss";
import { URLS_PHP_8 } from "constants/urls_v2";
import { ApiKeyFetch } from "api/fetchers/apiKey";

const HogarCoberturas = ({
  params: { idCotizacion },
  addWarningToast,
  addSuccessToast,
  dataUsuario,
  ...props
}) => {
  const history = useHistory();

  useNavbarContext(Hogar.codProducto);
  const { cliCodigoCore } = dataUsuario;
  const [loading, setLoading] = useState(true);
  const [catalogo, setCatalogo] = useState({});

  const methods = useForm({
    mode: "onChange",
  });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    if (!idCotizacion) {
      history.replace("/");
      history.push(Hogar.urls.datosPersonales);
    }
  }, [idCotizacion]);

  const solicitarCatalogos = async () => {
    const solicitudCatalogos = {
      ambiente: ambienteAplicacion,
      prodCodigo: Hogar.codProducto,
      prodCodigoCore: Hogar.prodCodigoCore,
      datosCotizador: {
        prodCodigo: Hogar.codProducto,
        idCotizacion: idCotizacion,
        cotPasoCodigo: {
          descripcion: "planes",
        },
      },
    };

    return await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.catalogosCotizador, solicitudCatalogos);
  };

  const solicitarResumen = async () => {
    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: idCotizacion,
      },
    };

    //Obtener la informacion personal del cliente
    return await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.resumenCotizacion, DataResumen);
  };

  const getData = async () => {
    const resCatalogos = await solicitarCatalogos();
    if (resCatalogos?.transaccion === true) {
      setCatalogo(resCatalogos?.catalogo);
    }
    console.log("Catalogos", resCatalogos);

    const resResumen = await solicitarResumen();

    if (resResumen?.transaccion === true) {
      const planSeleccionado = resResumen?.cotConsulta?.prodDatos?.find(
        (plan) => plan?.seleccionado === true
      );

      reset({
        coberturas: { planSeleccionado: planSeleccionado?.id },
      });
    }

    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);

    const planesCatalogo = catalogo?.paquetes;
    const respuestaEnviar = planesCatalogo?.map((item) => {
      let seleccionado = false;
      const planes = item?.planes?.map((plan) => {
        if (plan?.id === data?.coberturas?.planSeleccionado) {
          seleccionado = true;
        }
        return {
          ...plan,
          seleccionado: plan?.id === data?.coberturas?.planSeleccionado,
        };
      });

      return { ...item, seleccionado, planes };
    });

    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: Hogar.codProducto,
      prodCodigoCore: Hogar.prodCodigoCore,
      proTipoPlan: Hogar.proTipoPlan,
      tarifacionPantallaDos: false,
      pasoCodigo: "planSeleccionado",
      items: {
        planes: respuestaEnviar,
        cotCodigo: idCotizacion,
        usuCotiza: cliCodigoCore || "",
      },
    };

    const res = await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.actualizarCotizacion, Data);

    if (res?.transaccion === true && res?.id) {
      history.push(`/hogar3/${idCotizacion}`);

      reset(data);
    } else {
      addWarningToast("Error al guardar cobertura seleccionada", {
        autoDismiss: false,
      });
      reset(data);
    }

    setLoading(false);
  };

  const handleRegresar = () => {
    history.push(`${Hogar.urls.datosPersonales}/${idCotizacion}`);
  };

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <Breadcrumcomponent {...pasosBreadCrumbHogar.breadCrumb} showPaths={false} />

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR].breadCrumbPasosCotizacion[2]}
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.HOGAR]?.pasosCotizacion}
          />
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className='row justify-content-center mx-2'>
                <div className='col-12'>
                  <DatosGenerales
                    catalogo={catalogo}
                    addWarningToast={addWarningToast}
                    handleRegresar={handleRegresar}
                  />
                </div>
              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(HogarCoberturas);
